import type { LeaderboardEntry } from "@bentolabs/points-worker";

import { QueryOptions } from "@bentolabs/kit/types";
import { useQuery } from "@tanstack/react-query";

export const usePointsLeaderboardQuery = <TData = LeaderboardEntry[]>(
  options?: QueryOptions<LeaderboardEntry[], unknown, TData>
) => {
  return useQuery<LeaderboardEntry[], unknown, TData>({
    queryKey: ["points", "leaderboard"],
    staleTime: Infinity,
    queryFn: async () => {
      const response = await fetch("/points/leaderboard");
      const data: LeaderboardEntry[] = await response.json();

      return data;
    },
    ...options,
  });
};
